import { setAllContent,setFilteredContent,setQnas } from '../actions/index';

export const fetchQnasById = (qnaId) => (dispatch,getState) => {
    var myHeaders = ({
      'Accept' : 'application/json',
      'Content-Type': 'application/json'
  });

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  return fetch(`https://recruitingmonk-v2.azurewebsites.net/qna/${qnaId}`, requestOptions)
      .then(response => {
          if(response.ok) {
              console.log(response)
              return response;
          }
          else {
              var error = new Error("Error " + response.status + ": " + response.statusText);
              error.response = response;
              throw error;
          }
      }, 
      error => {
          var errmess = new Error(error.message);
          throw errmess;
      })
      .then(response => response.json())
      .then(data => {
          dispatch(setQnas([data]));
          dispatch(setAllContent([data]))
          dispatch(setFilteredContent([data]))
      })
      .catch(console.log);
}